var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9796 20.3996C18.124 20.2395 18.1933 20.0259 18.1709 19.8119L18.1709 19.8119L16.678 5.59562L16.678 5.59558C16.6373 5.20895 16.3114 4.9153 15.9225 4.9153H13.2917V4.45057C13.2917 2.35981 11.5908 0.658984 9.50007 0.658984C7.40916 0.658984 5.70833 2.3598 5.70833 4.45057V4.9153H3.07746C2.68858 4.9153 2.36267 5.20895 2.32199 5.59558L2.32198 5.59562L0.829131 19.8119L0.829124 19.8119C0.806727 20.026 0.876252 20.2395 1.02004 20.3994L1.02019 20.3996C1.16426 20.5594 1.36944 20.6507 1.58461 20.6507H17.4152C17.6305 20.6507 17.8357 20.5595 17.9796 20.3996ZM17.9796 20.3996L17.8497 20.2824M17.9796 20.3996C17.9797 20.3995 17.9797 20.3995 17.9797 20.3995L17.8497 20.2824M17.8497 20.2824C17.7389 20.4054 17.581 20.4757 17.4152 20.4757H1.58461C1.41902 20.4757 1.26107 20.4054 1.15018 20.2824L17.9968 19.8301C18.0141 19.9948 17.9607 20.1592 17.8497 20.2824ZM7.2275 4.45057C7.2275 3.19779 8.24713 2.17815 9.50007 2.17815C10.7529 2.17815 11.7725 3.19778 11.7725 4.45057V4.9153H7.2275V4.45057ZM15.2385 6.43446L16.5719 19.1315H2.42812L3.76148 6.43446H5.70833V7.54776C5.70833 7.9672 6.04848 8.30735 6.46792 8.30735C6.88735 8.30735 7.2275 7.9672 7.2275 7.54776V6.43446H11.7725V7.54776C11.7725 7.9672 12.1126 8.30735 12.5321 8.30735C12.9515 8.30735 13.2917 7.9672 13.2917 7.54776V6.43446H15.2385Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 0.35,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.d23eff105b2029cdad24248da002bc12.svg";
export { ForwardRef as ReactComponent };